import { css } from '@emotion/react'
import { LandingPageHeroTitle } from 'components/landingPageHero/LandingPageHeroTitle'
import { LandingPageTextImageButton } from 'components/landingPageTextImageSection/LandingPageTextImageButton'
import { LandingPageTextImagePerks } from 'components/landingPageTextImageSection/LandingPageTextImagePerks'
import { LandingPageTextImageSection } from 'components/landingPageTextImageSection/LandingPageTextImageSection'

import DashlaneLogo from 'images/extra-svg/DashlaneLogo.svg'
import { useTranslation } from 'next-i18next'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { colors } from 'utils/colors'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { numberRange } from 'utils/general'
import { mapKeysToTrans } from 'utils/i18n/mapKeysToTrans'
import { BREAKPOINTS } from 'utils/styled'

export function DashlaneHeroSection() {
  const { t } = useTranslation('dashlane')
  const { isLogged } = useAuth()
  const images = useContentfulImages()
  const ctaUrl = isLogged ? '/me/dashboard?dashlane=true' : '/signup'

  const perks = mapKeysToTrans(
    t,
    numberRange(4).map((i) => `dashlane.hero.perk_${i}` as const)
  )

  return (
    <LandingPageTextImageSection
      image={images.dashlane_hero}
      mobileImage={images.dashlane_hero_mobile}
      icon={<DashlaneLogo />}
      title={<LandingPageHeroTitle title={t('dashlane.hero.title')} />}
      backgroundColor={colors.gray[50]}
      css={css`
        padding-top: 3rem;
        @media ${BREAKPOINTS.MD.max} {
          padding-top: 0;
        }
      `}
    >
      <LandingPageTextImagePerks perks={perks} />
      <LandingPageTextImageButton href={ctaUrl} size="large" tone="dark">
        {t('dashlane.hero.cta')}
      </LandingPageTextImageButton>
    </LandingPageTextImageSection>
  )
}
